

import { mapState } from 'vuex'
import { mdiInformation } from '@mdi/js'
import Gallery from '@/components/catalog/product/images/Gallery'
import time from '@/components/tools/time'
import MotorhomeDetailsCards from '@/components/catalog/product/MotorhomeDetailsCards'
import TrailerDetailsCards from '@/components/catalog/product/TrailerDetailsCards'
import NewAuctionActionsWrapper from '@/components/catalog/product/NewAuctionActionsWrapper'
import ProductLocation from '@/components/catalog/product/ProductLocation'

export default {
  components: {
    ProductLocation,
    NewAuctionActionsWrapper,
    TrailerDetailsCards,
    MotorhomeDetailsCards,
    Gallery
  },
  props: {},

  data: () => {
    return {
      mdiInformation,
      tabProfile: [],
      tabEquipment: [],
      tabDescriptionAndDamages: [],
      tab: [],
      width: 600,
      height: 400,
      tabTitleClass: 'text-h6'
    }
  },

  computed: {
    ...mapState('customer', {
      customer: state => state.customer,
      isMerchant: state => typeof state.merchant?.merchantId === 'number',
      merchantAcceptedByCm24 (state) {
        if (state.merchant.acceptedByCm24) {
          return state.merchant.acceptedByCm24 === true
        } else {
          return false
        }
      }
    }),

    ...mapState('product', {
      product: state => state.data,
      lat: state => state.data?.location?.lat,
      lon: state => state.data?.location?.lon,
      zipcode: state => state.data?.position?.zipCode,
      countryCode: state => state.data?.position?.countryCode,
      country: state => state.data?.position?.country,
      city: state => state.data?.position?.city,

      status: state => state.data?.auction?.status,
      endingAt: state => time.parseDate(state.data?.auction?.endingAt),
      startingAt: state => time.parseDate(state.data?.auction?.startingAt),
      hasCustomerContext: state => state.data?.context !== null && state.data?.context?.holdingHighestBid !== null,
      damagesExists: state => state.data?.damages?.length > 0,
      defectsExists: (state) => {
        if (state.data?.attributes) {
          const found = Object.values(state.data?.attributes)?.find(attribute => attribute.attributeCode === 'defects_exists')
          if (found) {
            return found?.optionLabel?.toLowerCase() === 'ja'
          } else {
            return false
          }
        } else {
          return false
        }
      },
      publishedWithoutReview: state =>
        Object.values(state.data?.attributes)?.find(attribute => attribute.attributeCode === 'published_without_review' && attribute.value === true)

    }),

    isOwner () {
      return this.$auth.loggedIn && this.customer?.customerId && this.customer?.customerId === this.product?.customerId
    },
    isTrailer () {
      return this.product?.productType === 'trailer'
    },

    orderOfTitleCol () {
      // consolo.log(this.$vuetify.breakpoint.name)

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 2
        case 'sm':
          return 2
        default:
          return 0
      }
    },
    isOnWatchList () {
      return this.product?.context?.watchlist === true
    },
    hasBiddingContext () {
      return !(this.product?.context?.holdingHighestBid === undefined || this.product?.context?.holdingHighestBid === null)
    },
    buyNowEnabled () {
      return this.product.auction?.buyNowEnabled && this.product.auction?.buyNowPrice != null && this.product.auction.hasBids === false
    },
    privateAuction () {
      return this.product?.auction?.privateAuction
    }
  }

}
